import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactItemParts = [
  'container',
  'dataContainer',
  'labelContainer',
  'labelText',
  'primaryBadge',
  'numberText',
  'hStack',
  'empty_container',
  'empty_icon',
  'empty_text',
] as const

const helpers = createMultiStyleConfigHelpers(ContactItemParts)

export const ContactItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingY: '1.25rem',
      borderBottom: '1px solid',
      borderColor: 'border.default',
    },
    dataContainer: {
      flexDirection: 'column',
      gap: '0.25rem',
    },
    labelContainer: {
      alignItems: 'center',
      gap: '0.25rem',
    },
    labelText: {
      ...textStyles[textStyleKeys.Body1],
    },
    primaryBadge: {
      alignItems: 'center',
      height: '1.125rem',
      paddingX: '0.5rem',
      backgroundColor: 'border.default',
      color: 'brand.contrast',
      fontSize: '0.6875rem',
      fontWeight: '700',
      borderRadius: '0.25rem',
    },
    numberText: {
      ...textStyles[textStyleKeys.H6],
    },
    hStack: {
      gap: '0.25rem',
    },
    empty_container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingY: '3.75rem',
      gap: '1.25rem',
      borderBottom: '1px solid',
      borderColor: 'border.default',
    },
    empty_icon: {
      boxSize: '6.25rem',
      color: 'border.default',
    },
    empty_text: {
      ...textStyles[textStyleKeys.H6],
      textAlign: 'center',
      color: 'border.default',
    },
  },
})

export const useContactItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactItemStyle, props) as MultiStyleType<
    typeof ContactItemParts
  >
}
